export const stockMovementSourceLabel = {
  shopify: 'Shopify',
  amazon: 'Amazon',
  logistics: 'Logistics',
  manual: 'Manual',
  'inventory-ledger': 'Ledger',
}

export const skuToProduct = (sku) => {
    if(sku) {
      if (sku.includes('CAR-WKDP')){
        return 'Weekender Plus'
      }

      if(sku.includes('COV-TRK')) {
        const skuSub = sku.substring(0,8)
        const longNames = {
          'COV-TRKS': 'Carry On Checked Cover',
          'COV-TRKL': 'Trunk Checked Cover',
        }
        return longNames[skuSub]
      } else if(sku.includes('DBK') || sku.includes('CAR') || sku.includes('TRK') || sku.includes('BOT') || sku.includes('SET')) {
        const skuSub = sku.substring(0,7)
        const longNames = {
          'CAR-POC': 'Pocket',
          'CAR-SLI': 'Sling',
          'CAR-DPK': 'Daypack',
          'CAR-TOT': 'Tote',
          'CAR-BPK': 'Backpack',
          'CAR-WKD': 'Weekender',
          'DBK-TOT': 'Daybreak Tote',
          'DBK-BPK': 'Daybreak Backpack',
          'DBK-WKD': 'Daybreak Weekender',

          'TRK-COP': 'Carry On Trunk',
          'TRK-CHK': 'Checked Trunk',
          'BOT-LAR': 'Bottle 750ml',
          'BOT-SML': 'Bottle 500ml',

          'SET-CHK': 'Carry on + Checked Set',
          'SET-PLS': 'Carry on + Plus Set',
          'SET-FML': 'Family Set',
          'SET-TRK': 'Trunk Set',
        }
        return longNames[skuSub]
      } else {
        var start = sku.split("-")[0].slice(0,3);
        const names = {
          'IPC': 'iPhone Case',
          'COP': 'Carry On',
          'PRO': 'Carry On Pro',
          'CHK': 'Checked',
          'PLS': 'Checked Plus',
          'CME': 'Carry ME',
          'TOT': 'Tote',
          'WKD': 'Weekender',
          'BPK': 'Backpack',
          '8PC': '8 Packing Cells',
          '4PC': '4 Packing Cells',
          'PB0': 'Power Bank',
          'LGT': 'Carry On Light',
          'NBK': 'Notebook',
          'TEC': 'Tech Kit',
        }
        return names[start]
      }
    }
    return ''
}

const isCarryAll = (sku) => {
  if(sku) {
    var start = sku.split("-")[0].slice(0,3);
    const names = {
      'IPC': false,
      'LGT': false,
      'COP': false,
      'CHK': false,
      'PLS': false,
      'CME': false,
      'TOT': true,
      'WKD': true,
      'BPK': true,
      '8PC': false,
      '4PC': false,
    }
    return names[start]
  }
  return false
}

// Product families that can be sold personalised. Matched as a prefix of the SKU's first
// segment, so 'COP' covers COPB41 and 'JET' covers JETTE-TOT2-LRG13.
export const personalisableSkuPrefixes = [
  'COP', 'CHK', 'PLS', 'CME', 'BKP', 'BPK', 'WKD', 'TOT', 'PRO', 'LGT', 'BOT', 'IPC',
  'TRK', 'NBK', 'TAG', 'SET', 'TEC', 'COE', 'EXP', 'EVE', 'DBK', 'SLG', 'JET', 'COM',
  'CSL',
]

// Families whose first segment carries the model number, so it changes with every model:
// CO47, CO51, … (Carry On Classic with CaseSafe). A three-letter prefix can't express
// these — slice(0, 3) of 'CO51' is 'CO5', not 'CO4' — which is why 'CO4' was hard-coded
// and each new model number silently lost its personalisation option. Anchored on a digit
// so COV- (covers) and COM- don't match by accident.
const personalisableSkuModelFamilyPattern = /^CO\d/

// Families where the first segment is too broad on its own: 'CAR' also covers CAR-POC and
// CAR-SLI, which aren't personalised.
export const personalisableSkuSegmentPrefixes = [
  'CAR-DPK', 'CAR-TOT', 'CAR-BPK', 'CAR-WKD', 'CAR-SPL', 'CLASSIC-TRK',
]

// Whether the line-item pickers should offer a personalised option for this SKU. The
// personalised SKU is the base SKU plus a `-P` segment and is not a variant in the
// catalogue, so the pickers have to synthesise the option — hence this check.
export const isPersonalisableSku = (sku) => {
  if (!sku) return false
  const firstSegment = sku.split('-')[0]
  return (
    personalisableSkuPrefixes.some((prefix) => firstSegment.startsWith(prefix)) ||
    personalisableSkuModelFamilyPattern.test(firstSegment) ||
    personalisableSkuSegmentPrefixes.some((prefix) => sku.startsWith(prefix))
  )
}

export const caseColors = {
    'NAV': '#002551',
    'BUR': '#d71f27',
    'NUD': '#d8a68b',
    'CHA': '#000000',
    'FOR': '#084221',
    'MON': '#000000'
}

export const newColors = {
  'Lavender': '#90759B',
  'Lilac': '#DCC5DF',
  'Ballet-Pink': '#F1C9DE',
  'Rose-Pink': '#DC75A4',
  'Grenaine': '#9E5360',
  'Blush-Pink': '#E77472',
  'Magenta': '#B12D52',
  'Maroon': '#731A29',
  'Red': '#C92327',
  'Burnt-Orange': '#DC5527',
  'Mango': '#EF7E2E',
  'Rust': '#9B4827',
  'Toffee': '#705037',
  'Taupe': '#D3A289',
  'Butter-Yellow': '#FBF3BE',
  'Yellow': '#E8B629',
  'Lime': '#C6B937',
  'Green': '#4A813C',
  'Forest-Green': '#034123',
  'Mint': '#78AB93',
  'Ice-Blue': '#BEE3E9',
  'Denim': '#75A6B3',
  'Ocean-Blue': '#3E8EA1',
  'Blue': '#1466B2',
  'Grey': '#95979E',
  'Slate-Grey': '#63727E',
  'Black': '#000000',
  White: '#FFFFFF',
  // New luggage text colours from `feat: Add more personalise colors` (3b1f9f0a) on july.com.
  Bone: '#F9F4EA',
  Khaki: '#47431C',
  Espresso: '#41260D',
}


export const colors = {
    'Cream':    '#FAD6BC', //CREAM
    'Pink':     '#BC2C55', //Pink
    'Coral':    '#F4827A', //Coral
    'Red':      '#DA372B', //Red
    'Yellow':   '#feed67', //Yellow
    'Lime':     '#959D38', //Lime
    'Blue':     '#118AA4', //Blue
    'White':    '#FFFFFF', //White
    'Grey':     '#A6A9AE', //Grey
    'Black':    '#000000', //Black
}
export const fonts = {
  // Personalisation Refresh (.01-.11). The -new keys are refresh replacements; the
  // un-suffixed keys below stay listed so historical orders still display correctly.
  'stencil': 'Stencil',
  'dolce': 'Dolce',
  'sharpie': 'Sharpie',
  'storybook': 'Storybook',
  'signwriter': 'Signwriter',
  'monogram': 'Monogram',
  'sans-serif-new': 'Sans Serif (new)',
  'autograph': 'Autograph',
  'love-letter-new': 'Love Letter (new)',

  'heritage': 'Heritage',
  'bold-new': 'Bold (new)',
  'bubble': 'Bubble',
  'retro-serif': 'Retro Serif',
  'graphic': 'Graphic',
  'sans-serif': 'Sans Serif',
  block:  'Block',
  signature: 'Signature',
  retro: 'Retro',
  serif: 'Serif',
  decorative: 'Decorative',
  'love-letter': 'Love Letter',

  painted: 'Painted',
  college: 'College',
  script: 'Script',
  casual: 'Casual',
  wide: 'Wide',
  bold: 'Block Serif',
  cursive: 'Modern Script',
  modern: 'Modern Serif',
  'zh-ser': 'Chinese Serif',
  'zh-san': 'Chinese Sans Serif',
  'zh-block': 'Chinese Block',
  'zh-script': 'Chinese Script',
  'zh-casual': 'Chinese Casual',
}

// Fonts that paint a shadow layer under the face and therefore REQUIRE monogram_shadow.
// Must stay in sync with `layeredFonts` in the MMS repo's functions/index.js and with
// MonogramService.validateMonogramRequest — both reject one of these submitted without a
// valid shadow colour, and the PDF is then never written.
//
// The Personalisation Refresh added monogram (.10) and signwriter (.11) here. Until they
// were added to the pickers below, editing one of those line items dropped its shadow and
// the regenerate silently failed.
export const layeredFonts = ['block', 'heritage', 'monogram', 'signwriter']

// Fonts that accept a shadow colour at all. college takes one as a -webkit-text-stroke
// outline rather than a layer, so it is offered but not required. `decorative` used to be
// in this list by mistake — it ignores monogram_shadow entirely.
export const shadowFonts = [...layeredFonts, 'college']

export const lineHeights = {
    block: 105,
    script: 184,
    casual: 184,
    wide: 184,
    serif: 184,
    'zh-ser': 184,
    'zh-san': 184,
}
export const locations = [
    'Top',
    'Side',
    'Back'
]

export const skuToColor = (sku) => {
  if (!sku) return ''
  const colorAbreviation = sku.split('-').filter((val) => { return (val !== 'P' && val !== 'LE') }).join('-').split("-").pop().replace(/[0-9]/g, '')
  const names = {
    'NAV': 'NAVY',
    'CHA': 'CHARCOAL',
    'FOR': 'FOREST',
    'NUD': isCarryAll(sku) ? 'CHALK' : 'SAND',
    'BUR': 'BURGUNDY',
    'MON': 'MONOCHROME',
    'CLY': 'CLAY',
    'CLA': 'CLAY',
    'SKY': 'SKY',
    'SHW': 'SHADOW',
    'SHA': 'SHADOW',
    'BLA': 'Midnight Black',
    'TAU': 'Natural Taupe',
    'CHK': 'Chalk White',
    'SNO': 'Snow',
    'SAN': 'Sand',
    'LGR': 'Light Grey',

    'GRY': 'Stone',
    'OLI': 'Moss',
    'PIN': 'Rose',

    'SAP': 'Sapphire Blue',
    'HYD': 'Hydrangea Blue',
    'RED': 'Scarlet Red',
    'GRE': 'Myrtle Green',
    
    
  }
  return names[colorAbreviation]
}
